import React from 'react';
import { Link, Typography, Box, Grid } from '@mui/material';

export default function VariationPanel({ microContent, variation }) {
    return (
        <Box sx={{ pt: 3 }}>
            {
                {
                    SPARK: <ContentPanelSpark variation={variation} />,
                    LINK: <ContentPanelLink variation={variation} />,
                    MANUAL: <ContentPanelManual variation={variation} />,
                }[microContent.content?.type]
            }
            <VariationCommsPanel variation={variation} />
        </Box>
    );
}

function VariationCommsPanel({ variation }) {
    return (
        <Grid container colSpacing={1} rowSpacing={3} sx={{ mt: 3 }}>
            <Grid item xs={2}>
                <Typography>Email Copy</Typography>
            </Grid>
            <Grid item xs={10}>
                <Box
                    sx={{
                        p: 2,
                        border: 1,
                        borderRadius: 1,
                        flex: 1,
                        minHeight: 200,
                        maxHeight: 200,
                        overflow: 'auto',
                        backgroundColor: '#fff',
                    }}
                >
                    {variation.emailText}
                </Box>
            </Grid>
            <Grid item xs={2}>
                <Typography>SMS Copy</Typography>
            </Grid>
            <Grid item xs={10}>
                <Box
                    sx={{
                        p: 2,
                        border: 1,
                        borderRadius: 1,
                        flex: 1,
                        minHeight: 100,
                        maxHeight: 100,
                        overflow: 'auto',
                        backgroundColor: '#fff',
                    }}
                >
                    {variation.smsText}
                </Box>
            </Grid>
        </Grid>
    );
}

function ContentPanelSpark({ variation }) {
    if (!variation) {
        return <Typography type="error">ERROR : Invalid variation.</Typography>;
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={2}>
                <Typography>Spark</Typography>
            </Grid>
            <Grid item xs={10}>
                <Box
                    sx={{
                        p: 2,
                        border: 1,
                        borderRadius: 1,
                        flex: 1,
                        backgroundColor: '#fff',
                    }}
                >
                    <Typography>{variation.displayName} </Typography>
                    <br />
                    <Link
                        underline="always"
                        href={`https://eee-dev.amazingco.me/content?sparkId=${variation.sparkId}`}
                        target="_blank"
                    >
                        {' '}
                        [ preview ]
                    </Link>
                    <Link
                        underilne="always"
                        href={`https://aex-hq-dev.amazingco.me/sparks/${variation.sparkId}`}
                        target="_blank"
                    >
                        {' '}
                        [ AEX ]
                    </Link>{' '}
                    ({variation.sparkId})
                </Box>
            </Grid>
        </Grid>
    );
}

function ContentPanelLink({ variation }) {
    if (!variation) {
        return <Typography type="error">ERROR : Invalid variation.</Typography>;
    }
    return (
        <Grid container spacing={1} flex={1}>
            <Grid item xs={2}>
                <Typography>Link Url</Typography>
            </Grid>
            <Grid item xs={10}>
                <Link
                    underline="always"
                    href={variation.LinkUrl}
                    target="_blank"
                >
                    {variation.LinkUrl}
                </Link>
            </Grid>
            <Grid item xs={2}>
                <Typography>Link Text</Typography>
            </Grid>
            <Grid item xs={10}>
                {variation.LinkText}
            </Grid>
        </Grid>
    );
}

function ContentPanelManual({ variation }) {
    if (!variation) {
        return <Typography type="error">ERROR : Invalid variation.</Typography>;
    }
    return (
        <Grid container spacing={1} flex={1}>
            <Grid item xs={2}>
                <Typography>Content</Typography>
            </Grid>
            <Grid item xs={10}>
                {variation.manualText}
            </Grid>
        </Grid>
    );
}
